import * as React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'

import Button from '../ui/button'

import { ProfileShort } from '../../store/commonTypes'

import UserInfoDescription from './userInfoDescription'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import paths from '../../paths'
import './styles.sass'
import { RootState } from '../../store/rootReducer'
import LoginDialog from '../informationWindow/loginDialog'

interface Props {
    profile: ProfileShort
}

const UserInfo: React.FunctionComponent<Props> = ({ profile }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()

    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const user = useSelector((state: RootState) => state.member.user)

    const [loginDialog, setLoginDialog] = useState(false)

    const handleSendMessage = () => {
        if (loggedIn && user && user.active === 1) {
            history.push(createLocalizedPath(`/membre/pm/conversations?pm=${profile.id}`))
        } else {
            setLoginDialog(true)
        }
    }

    return (
        <div className="user">
            <div className="userInfo">
                <Link to={paths.profile.toPath({ nick: profile.nick })}>
                    <img className="avatar" alt="" src={profile.avatar_url} />
                </Link>
                <UserInfoDescription profile={profile} />
            </div>
            <Button label={t('Send a message')} onClick={handleSendMessage} />
            {typeof window !== 'undefined' ? (
                createPortal(<LoginDialog loginDialog={loginDialog} setLoginDialog={setLoginDialog} />, document.body)
            ) : (
                <></>
            )}
        </div>
    )
}

export default UserInfo
